import React from 'react';
import { GREY_STAR, HALF_STAR, HALF_STAR_GRADIENT_HOVER_ID, HALF_STAR_GRADIENT_ID, QUARTER_STAR, QUARTER_STAR_GRADIENT_HOVER_ID, QUARTER_STAR_GRADIENT_ID, STAR_FILL_MAP, THREE_QUARTER_STAR, THREE_QUARTER_STAR_GRADIENT_HOVER_ID, THREE_QUARTER_STAR_GRADIENT_ID, YELLOW_STAR } from './Ratings.constants';
import { StarGradientContainer } from './Ratings.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const STAR_GRADIENT_CONFIG = [{
  starType: QUARTER_STAR,
  id: QUARTER_STAR_GRADIENT_ID,
  hoverId: QUARTER_STAR_GRADIENT_HOVER_ID,
  offset: '25%'
}, {
  startType: HALF_STAR,
  id: HALF_STAR_GRADIENT_ID,
  hoverId: HALF_STAR_GRADIENT_HOVER_ID,
  offset: '50%'
}, {
  starType: THREE_QUARTER_STAR,
  id: THREE_QUARTER_STAR_GRADIENT_ID,
  hoverId: THREE_QUARTER_STAR_GRADIENT_HOVER_ID,
  offset: '75%'
}];
export const StarGradients = () => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: STAR_GRADIENT_CONFIG.map(_ref => {
      let {
        id,
        hoverId,
        offset
      } = _ref;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StarGradientContainer, {
          children: /*#__PURE__*/_jsxs("linearGradient", {
            id: id,
            children: [/*#__PURE__*/_jsx("stop", {
              offset: offset,
              stopColor: STAR_FILL_MAP[YELLOW_STAR].fill
            }), /*#__PURE__*/_jsx("stop", {
              offset: offset,
              stopColor: STAR_FILL_MAP[GREY_STAR].fill
            })]
          })
        }), /*#__PURE__*/_jsx(StarGradientContainer, {
          children: /*#__PURE__*/_jsxs("linearGradient", {
            id: hoverId,
            children: [/*#__PURE__*/_jsx("stop", {
              offset: offset,
              stopColor: STAR_FILL_MAP[YELLOW_STAR].fillHover
            }), /*#__PURE__*/_jsx("stop", {
              offset: offset,
              stopColor: STAR_FILL_MAP[GREY_STAR].fillHover
            })]
          })
        })]
      });
    })
  });
};